import { Backend } from '../../../api/Backend';
import { ChannelModel } from '../../../api/EpgApi.types';
import { EpgEvent } from '../streamInfo/StreamInfo';
import { EpgScheduleHelper } from '../../EpgScheduleHelper';
import { LinearStreamInfo } from '../streamInfo/LinearStreamInfo';
import { hasReplayRights } from '../../detail/epg/EpgWatchability';
import { Log, Storage } from '@lightningjs/sdk';
import { ChannelManager } from '../../../api/ChannelManager';

const lastPlayedChannelKey = 'last-played-channel-id';

export class LiveChannelHandler {
  private defaultEpgEvent: EpgEvent | undefined;
  private defaultChannel: ChannelModel | undefined;

  constructor(private backend: Backend) {}

  init() {
    const savedChannelId = this.savedChannelId();
    return this.sortedChannels()
      .then(channels => {
        let savedChannel: ChannelModel | undefined;
        if (savedChannelId) {
          savedChannel = channels.find(c => c.channelId === savedChannelId);
        }
        this.defaultChannel = savedChannel ?? channels[0];
        return this.setEpgInfoForChannel();
      })
      .catch(err => {
        Log.error('Failed to start initial channel', err);
      });
  }

  private sortedChannels() {
    return ChannelManager.validChannels(this.backend, false).then(channels => {
      channels.validChannels.forEach(chan => {
        chan.findChannelNumber(this.backend);
      });

      channels.validChannels.sort(compareChannel);
      const favPromisses = channels.validChannels.map(el => el.updateFavorite(this.backend));
      return Promise.all(favPromisses).then(() => {
        const favs = channels.validChannels.filter(el => el.favorite);
        const other = channels.validChannels.filter(el => !el.favorite);
        return favs.concat(other);
      });
    });
  }

  private setEpgInfoForChannel() {
    if (this.defaultChannel) {
      return EpgScheduleHelper.getCurrentScheduleOfChannel(this.backend, this.defaultChannel?.channelId).then(info => {
        if (this.defaultChannel && info) {
          this.defaultEpgEvent = {
            channel: this.defaultChannel,
            program: info.program,
            schedule: info.schedule,
            season: info.season,
            series: info.series,
          };
        } else {
          this.defaultEpgEvent = undefined;
        }
      });
    }
    return Promise.resolve();
  }

  get streamInfo(): LinearStreamInfo | undefined {
    if (this.defaultEpgEvent && this.defaultChannel) {
      return new LinearStreamInfo(
        this.defaultEpgEvent,
        this.backend,
        hasReplayRights(this.defaultEpgEvent.schedule, this.defaultChannel)
      );
    }
    return undefined;
  }

  savedChannelId() {
    return Storage.get(lastPlayedChannelKey);
  }

  storeChannelId(channelId: string) {
    Storage.set(lastPlayedChannelKey, channelId);
  }
}

export function compareChannel(a: ChannelModel, b: ChannelModel): number {
  if (!a.channelNumber || !b.channelNumber) return 0;
  if (a.channelNumber < b.channelNumber) {
    return -1;
  }
  if (a.channelNumber > b.channelNumber) {
    return 1;
  }
  return 0;
}
